var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12"},[_c('span',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.carrega()}}},[_vm._v(" "+_vm._s(_vm.texto)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab2836f","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carrega.vue
// module id = 762
// module chunks = 245